import type { OverallTaskStatus } from '@kaiizen/kai-pro-api';

export const OVERALL_TASK_STATUS_VALUES: readonly OverallTaskStatus[] = [
  'empty',
  'draft',
  'approved',
  'notStarted',
  'inProgress',
  'needsRework',
  'completed',
];

const OVERALL_TASK_STATUS_SET = new Set<string>(OVERALL_TASK_STATUS_VALUES);

export const isOverallTaskStatus = (value: string): value is OverallTaskStatus => OVERALL_TASK_STATUS_SET.has(value);
